import { initTracking } from '@infra/datadog/tracking';

import '@libs/polyfills';
import { RouterProvider, createRouter } from '@tanstack/react-router';

import './index.css';
import { createRoot } from 'react-dom/client';

import { routeTree } from './routeTree.gen';

// Трэкинг
if (__RUNTIME.isProduction) {
  initTracking({
    applicationId: '3a6ee6e3-0248-4c1f-9e44-3a1de32d2bfe',
    clientToken: 'pub4a12b4e1c6da2beec8753b4475d298b3',
    service: 'play.chessopen.ru',
    env: 'prod',
  });
}

export const router = createRouter({
  routeTree,
  scrollRestoration: true,
  getScrollRestorationKey: (location) => {
    const paths = ['/club/\\d+$', '/club/\\d+/tournament/[0-9a-fA-F\\-]+$'];
    if (paths.some((p) => p === location.pathname || location.pathname.match(p))) {
      return location.pathname;
    }

    return location.state.__TSR_key!;
  },
});

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }

  interface HistoryState {
    backUrl?: string;
    // Урок, к которому нужно вернуться в списке учебной программы:
    // его курс и модуль разворачиваются, строка скроллится в видимую область
    revealLesson?: { courseId: number; lessonId: number };
  }
}

// Приложение
const doc = document.getElementById('root');
if (doc) {
  const root = createRoot(doc);
  root.render(<RouterProvider router={router} notFoundMode="root" />);
}
